var styles = {
raw: ".hcr-main-wrapper-8-6-0{background:var(--hcr-bg-primary-color);margin-top:0;min-height:100%;padding-bottom:0;position:relative}.hcr-main-wrapper--full-8-6-0{min-height:100vh}",
map:{"hcr-main-wrapper":"hcr-main-wrapper-8-6-0","hcr-main-wrapper--full":"hcr-main-wrapper--full-8-6-0"}};

export { styles as default };
